import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout-view',
  templateUrl: './logout-view.component.html',
  styleUrls: ['./logout-view.component.scss'],
  standalone: false,
})
export class LogoutViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
